import { render, staticRenderFns } from "./MobileSafetyRegularAssessmentAlways.vue?vue&type=template&id=9c2285ca&scoped=true&"
import script from "./MobileSafetyRegularAssessmentAlways.vue?vue&type=script&lang=js&"
export * from "./MobileSafetyRegularAssessmentAlways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2285ca",
  null
  
)

export default component.exports